import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import BookMore from '../bookMore/BookMore';
import { schedulePage, setOnboardingSkip } from '../../utils';
import './Footer.scss';

const handleSetOnboardingSkip = (type = '') => {
  if (type === 'skip' || type === 'done') {
    setOnboardingSkip();
  }
};

const getRedirectPath = (redirectPath, isArrivalTimePage, isTravelAgentBooking, isAfterLastArrivalDate) => {
  if (!isArrivalTimePage) return redirectPath;
  if (!isTravelAgentBooking && isAfterLastArrivalDate) return schedulePage;
  return redirectPath;
};

const getLinkChildren = (type) => {
  if (type === 'skip') return 'Skip';
  if (type === 'done') return 'Done';
  if (type === 'next') return 'Next';
  if (type === 'edit') return 'Edit booking';
  if (type === 'book-more') {
    return <BookMore text="Book more" />;
  }
  return null;
};

const Footer = ({
  showIndicators = false,
  activeIndicator = 1,
  numberOfIndicators = 5,
  buttonType = 'skip',
  redirectPath = '',
  showLink = false,
  isArrivalTimePage = false,
  isTravelAgentBooking = false,
  isAfterLastArrivalDate = false,
}) => {
  const indicators = [...Array(numberOfIndicators).keys()];

  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left-container">
          {showIndicators && (
            indicators.map(
              item => <div key={item} className={classnames('indicator', item === (activeIndicator - 1) && 'active')} />,
            )
          )}
        </div>
        <div className="right-container">
          {showLink
            && (
              <Link
                className={buttonType}
                to={getRedirectPath(redirectPath, isArrivalTimePage, isTravelAgentBooking, isAfterLastArrivalDate)}
                onClick={() => handleSetOnboardingSkip(buttonType)}
              >
                {getLinkChildren(buttonType)}
              </Link>
            )}
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  showIndicators: PropTypes.bool,
  activeIndicator: PropTypes.number,
  numberOfIndicators: PropTypes.number,
  buttonType: PropTypes.oneOf(['skip', 'done', 'edit', 'book-more', 'next']),
  redirectPath: PropTypes.string,
  showLink: PropTypes.bool.isRequired,
  isArrivalTimePage: PropTypes.bool,
  isAfterLastArrivalDate: PropTypes.bool,
  isTravelAgentBooking: PropTypes.bool,
};

export default Footer;
